export default [
  {
    description: 'Documento',
    path: '/ged/documento',
    name: 'ged-documento',
    component: () => import('@/views/ged/geddocumento/Index.vue'),
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Documento',
    parent: 'ged-documento',
    path: '/ged/documento/cadastro/:id?',
    name: 'ged-documento-create',
    component: () => import('@/views/ged/geddocumento/InclusaoEdicao.vue'),
    goesToMenu: false,
  },
];
